import React from 'react'
import Hero from '../../components/hero/Hero'
import PagesChecklist from '../../components/pages/PagesChecklist'
import './VisualDesign.css'
import ButtonMain from '../../components/ButtonMain'


function VisualDesign() {
    return (
        <div className="visualDesignWrapper">
            <Hero
            title="UX/UI & Visual Design."
            title2="Diseñamos experiencias interactivas 4.0."
            sub="Diseñamos experiencias e interfaces gráficas dinámicas, modernas e interactvias. Descubre todo un mundo en movimiento."
         
            />
            <PagesChecklist
                subtitle="Diseño interactivo y  prototipado de producto."
                checklist1="Experiencias de usuario snesioriales fullscreen."
                checklist2="Interfaces gráficas diniámicas e interactivas."
                checklist3="Navegación, interactividad y animaciones."
                checklist4="Diseño multidispositivo, tu producto en todos los soportes."
            />
            <div style={{height:"90px"}}/>
            <div style={{marginLeft:"10vw"}}>
            <ButtonMain mainbtn="¿Nos conectamos?"/>
            </div>
            </div>
    )
}

export default VisualDesign
